.paper {
  background-color: transparent;
  box-shadow: none;
  padding: 1rem;
}

.wrap {
  max-width: 40rem;
  margin: 0 auto;
  width: 100%;
  padding: 1.6rem;
}
